/**
 * Gives you what you think.. the application base url
 */
export function baseurl() {
    return `/${ globals.config.language }`;
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/router/constants.js